import { $, $$ } from '../helpers/selectors';

class Embeds {
  constructor() {
    if ($('.ceros-experience') && $('.page--embed .main')) {
      const cerosEmbeds = $$('.ceros-experience');
      cerosEmbeds.forEach(embed => {
        embed.parentElement.classList.add('ceros-embed');
      });
      $('.page--embed .main').classList.add('ceros-embedded');
    }
  }
}

export default Embeds;
